import { z } from "zod";
import env from "@/app/config/env";

export const normalizeImageUrl = (
  value: string,
  hostUrl: string = env.hosts.image,
): string => {
  if (!value) return "";

  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }

  let cleanValue = value.startsWith("/") ? value.slice(1) : value;

  if (!cleanValue.includes("images/") && !cleanValue.startsWith("images")) {
    cleanValue = `images/${cleanValue}`;
  }

  const cleanHostUrl = hostUrl.endsWith("/") ? hostUrl.slice(0, -1) : hostUrl;

  return `${cleanHostUrl}/${cleanValue}`;
};

export const DateValidation = z
  .string()
  .optional()
  .refine(
    (value?: string) => {
      try {
        if (!value) {
          return true;
        }
        const date = new Date(value);
        return !isNaN(date.getTime());
      } catch {
        return false;
      }
    },
    {
      message: "Invalid date format",
    },
  )
  .transform((value?: string) => value && new Date(value));
